import { render, staticRenderFns } from "./TicketDocuments.vue?vue&type=template&id=43fd24a1"
import script from "./TicketDocuments.vue?vue&type=script&lang=js"
export * from "./TicketDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports